import { render, staticRenderFns } from "./CarLoan.vue?vue&type=template&id=33ac952d"
import script from "./CarLoan.vue?vue&type=script&lang=ts"
export * from "./CarLoan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports